import { FullWidth } from 'ui/utility/fullWidth';
import { useDestination } from '../../../hooks/useDestination';
import { TransferHistoryPageHeader } from './sections/PageHeader';
import { DataSyncErrorState, DataSyncLoadingState } from '../common/DataSyncStates';

interface TransferHistoryPageProps {
  destinationId: string;
}

export const TransferHistoryPage = ({ destinationId }: TransferHistoryPageProps) => {
  const { destination, isLoading, error, refetch } = useDestination(destinationId);

  if (isLoading) {
    return (
      <FullWidth>
        <DataSyncLoadingState />
      </FullWidth>
    );
  }

  if (error || !destination) {
    return (
      <FullWidth>
        <DataSyncErrorState onRetry={refetch} />
      </FullWidth>
    );
  }

  return (
    <FullWidth>
      <TransferHistoryPageHeader destination={destination} destinationId={destinationId} />
      {/* TODO: Add transfer history table/component here */}
      <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
        Transfer history table will be implemented here
      </div>
    </FullWidth>
  );
};
